import { render, staticRenderFns } from "./ProceedToLogin.vue?vue&type=template&id=3f66ee67"
import script from "./ProceedToLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedToLogin.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports